import alertAssign from './alertAssign'

export const alertAssignService = alertAssign
